import React from "react";
import styles from "./Slider.module.scss";

const SliderButton = ({ func, direction, customStyles = {} }) => {
return (
    <button
        onClick={func}
        className={`group ${direction === -1 ? styles.arrowButtonLeft : styles.arrowButtonRight}`}
        style={customStyles}
    >
        {direction === -1 ? (
            <svg
                width="44px"
                height="44px"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                className="size-9 stroke-current text-black lg:group-hover:text-[#ff6f19] transition-colors duration-200"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.75 5.5 L3.75 12 L9.75 18.5"
                />
            </svg>
        ) : (
            <svg
                width="38px"
                height="38px"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                className="absolute top-[3px] right-[9px] size-9 stroke-current text-black lg:group-hover:text-[#ff6f19] transition-colors duration-200"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.25 5.5 L20.25 12 L14.25 18.5"
                />
            </svg>
        )}
    </button>
);

}

export default SliderButton;